import PropTypes from 'prop-types'
import dateFormat from 'dateformat'
import { compact } from 'lodash'

import { FORMAT_DATE_LONG } from 'lib/date'

const InsertCardOrderSummary = ({ insertCardOrder }) => {
  const {
    createdAt,
    id,
    quantity,
    shippingAddress: {
      city,
      country,
      name,
      phone,
      state,
      streetAddress1,
      streetAddress2,
      zip,
    },
    status,
  } = insertCardOrder
  return (
    <ul className="list-unstyled">
      <li>
        <strong>Order #IC-{id}</strong>
      </li>
      <li>
        <strong>Order Date:</strong> {dateFormat(createdAt, FORMAT_DATE_LONG)}
      </li>
      <li>
        <strong>Quantity:</strong> {quantity}
      </li>
      <li>
        <strong>Status:</strong> {status.toUpperCase()}
      </li>
      <li>
        <strong>Shipping To:</strong>
      </li>
      <li>{name}</li>
      <li>{compact([streetAddress1, streetAddress2]).join(', ')}</li>
      <li>{compact([city, state, zip]).join(', ')}</li>
      <li>{country}</li>
      {phone ? <li>Phone: {phone}</li> : null}
    </ul>
  )
}

InsertCardOrderSummary.propTypes = {
  insertCardOrder: PropTypes.object.isRequired,
}

export default InsertCardOrderSummary
